import logger from '@design-systems/logger';

/** a common utility to verify that all required prop elements exist */
export const checkForA11yProps = function (componentName, /** Component props */
props = {}, /** An array of strings with the names of props that are sufficient for accessibility */
propCheck = []) {
  const isMissingElements = propCheck.reduce(function (acc, key) {
    return acc && !props[key];
  }, true);
  if (isMissingElements) {
    logger.error(`${componentName} requires the use of one of these attributes: ${propCheck.join(', ')}`);
  }
};
//# sourceMappingURL=check-for-a11y-props.js.map